import { defineComponent, toRaw } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import CheckboxInput from '@/components/Base/Forms/Inputs/CheckboxInput.vue';
export default defineComponent({
    name: 'filter-universal',
    props: {
        filterType: {
            required: true,
            type: String,
        },
        filterHeadline: {
            required: true,
            type: String,
        },
    },
    components: {
        CheckboxInput,
    },
    data() {
        return {
            showAll: false,
            currentlySet: [],
        };
    },
    methods: Object.assign({ getCheckboxState(filter) {
            return (this.appliedFilters[this.filterType].find((appliedFilter) => appliedFilter.numericValue === filter.numericValue) !== undefined);
        },
        applyCheckbox(event) {
            const filter = {
                displayValue: '',
                numericValue: event.value,
            };
            const filters = structuredClone(toRaw(this.appliedFilters));
            let filterSet = filters[this.filterType];
            if (event.checked) {
                filterSet.push(filter);
            }
            if (!event.checked) {
                filterSet = filterSet.filter((filter) => filter.numericValue !== event.value);
            }
            filters[this.filterType] = filterSet;
            this.applyFilters(filters);
        },
        resetFilters() {
            const filters = structuredClone(toRaw(this.appliedFilters));
            filters[this.filterType] = [];
            this.applyFilters(filters);
        } }, mapActions('blue', {
        applyFilters: 'UPDATE_FILTERS',
    })),
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        availableFilters: 'availableFilters',
        appliedFilters: 'appliedFilters',
        currentPageInfo: 'currentPageInfo',
    })), { filterContent() {
            if (!this.availableFilters) {
                return [];
            }
            if (this.availableFilters[this.filterType] === undefined) {
                return [];
            }
            if (this.availableFilters[this.filterType] === null) {
                return [];
            }
            return this.availableFilters[this.filterType];
        },
        currentFilterItems() {
            const fullSet = structuredClone(toRaw(this.filterContent));
            fullSet.map((filter) => {
                filter.checked = this.getCheckboxState(filter);
            });
            return this.showAll ? fullSet : fullSet.slice(0, 5);
        } }),
});
